import { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { WithTranslation, withTranslation } from 'react-i18next';

import { useAssistant } from '@core/assistant/providers/Provider';
import { AWAITING_RESPONSE_TYPE } from '@core/assistant/interfaces';

import Message from './Message';
import { useStyles } from './styles';

interface IChatBoxTranslate extends WithTranslation {}

const ChatBox = ({ t: translate }: IChatBoxTranslate) => {
  const classes = useStyles();
  const {
    chatHistory,
    awaitingResponseType,
    isDisplayUserFeedback,
    handleSubmitUserFeedback,
    setIsDisplayUserFeedback,
    userName,
  } = useAssistant();
  const messagesEndRef = useRef<null | HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory]);

  return (
    <Box sx={classes.box}>
      {chatHistory.map((message) => (
        <Message key={message.timestamp} message={message} userName={userName} />
      ))}
      {awaitingResponseType === AWAITING_RESPONSE_TYPE.SHORT && (
        <SmsIcon sx={classes.awaitingResponse.smsIcon} />
      )}
      {awaitingResponseType === AWAITING_RESPONSE_TYPE.LONG && (
        <Box sx={classes.awaitingResponse}>
          <SmsIcon sx={classes.awaitingResponse.smsIcon} />
          <Box sx={classes.awaitingResponse.text}>
            {translate('assistant.runningExtendedSearch')}
          </Box>
        </Box>
      )}
      {isDisplayUserFeedback && (
        <Box sx={classes.feedback}>
          <Box sx={classes.awaitingResponse.text}>
            Would you like to receive a follow up to your question from
            Facilitator?
          </Box>
          <Box>
            <CheckIcon onClick={() => handleSubmitUserFeedback(true)} />
            <ClearIcon onClick={() => handleSubmitUserFeedback(false)} />
          </Box>
        </Box>
      )}
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default withTranslation('common')(ChatBox);
